export default __webpack_public_path__ + "static/media/slamdunkvv.14bab781.png";